<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New Pickup List</h2>
            <!-- <h3></h3> -->
        </div>
        <div slot="body">

            <div class="mx-4">
                <div class="container-fluid pt-5 pb-4">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="full">
                                Pickup Name
                                <span class="brand">
                                    *
                                </span>
                                <input type="text" class="bg-lighter" v-model="newPickup.name">
                            </label>
                        </div>
                        <div class="col-sm-6">
                            <label class="full">&nbsp;</label>
                            <div class="pt-2 fs-small color-1 pointer underlined">Copy existing List</div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid pt-3">
                    <div class="d-flex flex-columns w-100 py-2 bg-lighter border-top-light border-bottom-light dark fs-small font-weight-600">
                        <div class="col-sm-6 pr-5">
                            <div class="row">
                                <div class="col-sm-6">
                                    Location
                                </div>
                                <div class="col-sm-6">
                                    Location 2
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 pl-5">
                            <div class="row">
                                <div class="col-sm-10 text-center">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            Time 1
                                        </div>
                                        <div class="col-sm-4">
                                            Time 2
                                        </div>
                                        <div class="col-sm-4">
                                            Time 3
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="row">
                                        <div class="col-sm-12">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid">

                    <div class="d-flex flex-columns w-100 fs-small py-3  border-bottom-light" v-for="pickup,index in newPickup.locations">
                        <div class="col-sm-6 pr-5">
                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="text" class="bg-lighter w-100" v-model="pickup.location1">
                                </div>
                                <div class="col-sm-6">
                                    <input type="text" class="bg-lighter w-100" v-model="pickup.location2">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 pl-5">
                            <div class="row">
                                <div class="col-sm-10">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <input type="text" class="w-100 bg-lighter" v-model="pickup.times[0]">
                                        </div>
                                        <div class="col-sm-4">
                                            <input type="text" class="w-100 bg-lighter" v-model="pickup.times[1]">
                                        </div>
                                        <div class="col-sm-4">
                                            <input type="text" class="w-100 bg-lighter" v-model="pickup.times[2]">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="row">
                                        <div class="col-sm-12 text-center pt-2">
                                            <i class="ico-delete largest medium pointer" @click="removeRow(index)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="addRow">
                        <i class="ico-add fs-smallest add-circle color-1"></i> Add New
                    </div>

                </div>

            </div>


        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" @click="save">Save</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import {eventHub} from '../../main'

    export default {
        data: function() {
            return {
                newPickup: {
                    name: null,
                    locations:[
                        {
                            location1: null,
                            location2: null,
                            times:[
                                null,
                                null,
                                null
                            ]
                        }
                    ]
                }
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'addRouteToPickups'
            ]),
            cancel: function() {
                this.closeModal();
            },
            save: function() {
                this.addRouteToPickups(this.newPickup);
                this.closeModal();
            },
            addRow: function(){
                this.newPickup.locations.push({
                    location1: null,
                    location2: null,
                    times:[
                        null,
                        null,
                        null
                    ]
                });
            },
            removeRow: function(index){
                this.newPickup.locations.splice(index, 1);
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getProductEditPriceData'
            ])
        },

        components: {
            Modal,
            vSelect: extendedVSelect,
        }
    }
</script>

<style>
    .totalValue{
        font-size: 3rem;
    }
</style>



// WEBPACK FOOTER //
// CreatePickupList.vue?0ec25d67